import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    // Regular expression to find URLs in the text
    const urlRegex = /(\b(?:https?|ftp):\/\/|www\.)[^\s<>\[\]]+(?:\.[^\s<>\[\]]+)+(?:\S+)?/g;

    // Replace URLs with clickable links
    const replacedText = value.replace(urlRegex, (url) => {
      const href = url.startsWith('www.') ? 'http://' + url : url;
      return `<a href="${href}" target="_blank">${url}</a>`;
    });

    // Use DomSanitizer to make the HTML safe
    return this.sanitizer.bypassSecurityTrustHtml(replacedText);
  }
}